export default __webpack_public_path__ + "static/media/Item3.d5d671aa.png";